var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	43533: {
		fallback: () => (() => (__webpack_require__(14041))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "*",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react",
	},
	33391: {
		fallback: () => (() => (__webpack_require__(43144))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "*",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react-dom",
	},
	52932: {
		fallback: () => (() => (__webpack_require__(73657))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "*",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react-router-dom",
	},
	27158: {
		fallback: () => (() => (__webpack_require__(39723))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "*",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react-router-dom",
	},
	31081: {
		fallback: () => (() => (__webpack_require__(84976))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "*",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react-router-dom",
	},
	35040: {
		fallback: () => (() => (__webpack_require__(31085))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "*",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react/jsx-runtime",
	},
	44859: {
		fallback: () => (() => (__webpack_require__(47576))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "*",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "@asurion-core/mx-asurion-ui-react",
	},
	70282: {
		fallback: () => (() => (__webpack_require__(54057))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "*",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react-redux",
	},
	79646: {
		fallback: () => (() => (__webpack_require__(71468))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "*",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react-redux",
	},
	92144: {
		fallback: () => (() => (__webpack_require__(20759))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "*",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react-redux",
	}
};
var moduleToHandlerMapping = {};
__webpack_require__.consumesLoadingData.initialConsumes = [43533,33391];
__webpack_require__.federation.installInitialConsumes = () => (__webpack_require__.federation.bundlerRuntime.installInitialConsumes({
	initialConsumes: __webpack_require__.consumesLoadingData.initialConsumes,
	installedModules:installedModules,
	moduleToHandlerMapping,
	webpackRequire: __webpack_require__
}))
__webpack_require__.consumesLoadingData.chunkMapping = {
	"25": [
		27158,
		31081,
		35040,
		44859,
		70282,
		79646,
		92144
	],
	"755": [
		52932
	],
	"792": [
		43533,
		33391
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}